import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import '../../App.css'

const Banner = () => {
    const [banners, setBanners] = useState([]);
    const [imagePath, setImagePath] = useState('');
    const [showStoreModal, setShowStoreModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [currentBanner, setCurrentBanner] = useState({ id: '', title: '', image: '' });

    // Fetch banners from the API
    useEffect(() => {
        fetchBanners();
    }, []);


    const fetchBanners = async () => {
        try {
            const response = await fetch("https://bigbucks.badskullgaming.com/api/get-banners");
            const data = await response.json();
            setBanners(data.banners);
            setImagePath(data.imagePath);
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
    };

    const handleStoreBanner = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', currentBanner.title);
        formData.append('image', currentBanner.image);

        try {
            await fetch("https://bigbucks.badskullgaming.com/api/store-banner", {
                method: "POST",
                body: formData
            });
            setShowStoreModal(false);
            fetchBanners();
        } catch (error) {
            console.error("Error storing banner:", error);
        }
    };

    const handleUpdateBanner = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', currentBanner.title);
        if (currentBanner.image) {
            formData.append('image', currentBanner.image);
        }

        try {
            await fetch(`https://bigbucks.badskullgaming.com/api/update-banner/${currentBanner.id}`, {
                method: "PUT",
                body: formData
            });
            setShowUpdateModal(false);
            fetchBanners();
        } catch (error) {
            console.error("Error updating banner:", error);
        }
    };

    const handleDeleteBanner = async (id) => {
        try {
            await fetch(`https://bigbucks.badskullgaming.com/api/deletebanner/${id}`, {
                method: "DELETE"
            });
            fetchBanners();
        } catch (error) {
            console.error("Error deleting banner:", error);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setCurrentBanner({ ...currentBanner, image: file });
    };


    const handleShowUpdateModal = (banner) => {
        setCurrentBanner({ ...banner, image: null });
        setShowUpdateModal(true);
    };




    return (
        <>
            <div className="container ">
                <div className="d-flex justify-content-between my-3">
                    <h1 className="mb-4">Banner Management</h1>
                    <Button className="mb-3" style={{ backgroundColor: '#AFDDEA', borderColor: '#AFDDEA', color: 'var(--bs-white)' }} onClick={() => setShowStoreModal(true)}>Add New Banner</Button>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Title</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {banners.map((banner) => (
                            <tr key={banner.id}>
                                <td>{banner.id}</td>
                                <td>{banner.title}</td>
                                <td>
                                    <img
                                        src={`${imagePath}/${banner.image}`}
                                        alt={banner.title}
                                        style={{ width: '100px', height: 'auto' }}
                                    />
                                </td>
                                <td>
                                    <Button style={{ backgroundColor: '#AFDDEA', color: 'var(--bs-white)' }} size="sm" onClick={() => handleShowUpdateModal(banner)}>Edit</Button>{' '}
                                    <Button variant="danger" size="sm" onClick={() => handleDeleteBanner(banner.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Store Banner Modal */}
            <Modal show={showStoreModal} onHide={() => setShowStoreModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Banner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleStoreBanner}>
                        <Form.Group>
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                value={currentBanner.title}
                                onChange={(e) => setCurrentBanner({ ...currentBanner, title: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                                required
                            />
                        </Form.Group>
                        <Button type="submit" style={{ backgroundColor: '#AFDDEA', borderColor: '#AFDDEA', color: 'var(--bs-white)' }}>Save</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Update Banner Modal */}
            <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Banner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleUpdateBanner}>
                        <Form.Group>
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                value={currentBanner.title}
                                onChange={(e) => setCurrentBanner({ ...currentBanner, title: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                            />
                        </Form.Group>
                        <Button
                            type="submit"
                            style={{ backgroundColor: '#AFDDEA', color: 'var(--bs-white)' }} >
                            Update</Button>
                    </Form>
                </Modal.Body>
            </Modal>

        </>
    );
};

export default Banner;
